import React, { useState } from "react";
import { Carousel } from "antd";
import "./Home.css";
import "../../index.css";
import image1 from "../../Images/image1.webp";
import image2 from "../../Images/image2.webp";
import image3 from "../../Images/image3.webp";
import image4 from "../../Images/comumStore.webp";
import image6 from "../../Images/image6.webp";
import { useNavigate } from "react-router";
import { LocationComponent } from "../../Component/Location/LocationComponent";

const images = [
  {
    src: image1,
    alt: "",
    title: "Welcome to",
    message: "BAS Group",
  },
  {
    src: image2,
    alt: "",
    title: "Set the Wheels in Motion",
    message: "Ignite the Adventure",
  },
  {
    src: image6,
    alt: "",
    title: "#IgniteYourPotential",
    message: "Read More",
    link: "/our-value",
  },
  {
    src: image4,
    alt: "our store",
    title: "Comum Bike & Coffee",
    message: "Ride Hard, Sip Harder",
  },
];

const HomePage = () => {
  const navigate = useNavigate();
  const [activeSlide, setActiveSlide] = useState(0);

  return (
    <div className="layout home-layout">
      <Carousel
        arrows
        infinite={true}
        fade={true}
        effect="fade"
        speed={400}
        autoplay={{ dotDuration: true }}
        autoplaySpeed={6000}
        beforeChange={(current, next) => setActiveSlide(next)}
      >
        {images.map((image, index) => (
          <div className={`carousel-slide slide-${index}`} key={index}>
            <img className="image-carousel" src={image.src} alt={image.alt} />

            <div
              className={`carousel-text ${
                index === 0 ? "centered" : "bottom-left"
              }`}
            >
              <h1
                className={`carousel-title ${
                  index === activeSlide ? "popup-animation" : ""
                }`}
              >
                {image.title}
              </h1>
              <h2
                className={`carousel-message ${
                  index === activeSlide ? "popup-animation-delayed" : ""
                }`}
                onClick={image.link ? () => navigate(image.link) : undefined}
              >
                {image.message}
              </h2>
            </div>
          </div>
        ))}
      </Carousel>

      <div className="container about-us-container">
        <div className="text-button-container">
          <div className="text-container">
            <h1 className="title about-us-title">About Us</h1>
            <p className="subtitle about-us-subtitle">
              Bumi Agung Sukses, which is also known as BAS, was established in
              2012 as a retail store offering a wide range of products from a
              highly respected bicycle brand. With persistence and hard work, we
              were able to expand our business from solely distributing one
              brand to carrying multiple top-tier brands and expanding our
              dealer network throughout Indonesia. However, we didn't stop
              there. As a team, we are constantly striving to better ourselves
              and our company, and we remain committed to improving our services
              every day.
            </p>
          </div>
          <div
            className="button more-button"
            onClick={() => {
              navigate("about-us");
            }}
          >
            See More &gt;
          </div>
        </div>
        <div className="image-about">
          <img src={image3} alt="-" />
        </div>
      </div>
      <LocationComponent
        title="Location"
        address={
          <>
            Ruko Bumi Permata Indah Blok R1 No. 18 <br /> Jl. Raden Saleh No. 18
            RT. 001 RW. 012 <br />
            Karang Mulya - Karang Tengah, Tangerang
            <br />
            Banten
          </>
        }
        postCode={15157}
        email={"hr@bumiagungsukses.com"}
        mapSrc={
          "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3966.5207225617237!2d106.72190447413085!3d-6.19481296068825!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e69f7001b1b2297%3A0xf4e914439e80fce7!2sPT.%20BUMI%20AGUNG%20SUKSES!5e0!3m2!1sid!2sid!4v1736318600730!5m2!1sid!2sid"
        }
        mapTitle={"PT Bumi Agung Sukses"}
      />
    </div>
  );
};

export default HomePage;
